<template>
  <Fragment>
    <label v-if="label && options.length > 1">{{ label }}</label>
    <Component
      :is="useSelect ? `RsFormSelect` : `RsToggle`"
      v-if="options.length > 1"
      :key="toggleKey"
      :options="options"
      :value="input"
      @input="handleLanguageChange"
    />
  </Fragment>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ISelectOption } from '@/shared';

export default defineComponent({
  name: 'RsTranslationBadge',

  props: {
    resetOnMountAndDestroy: {
      type: Boolean,
      default: true,
    },

    useSelect: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: '',
    },

    options: {
      type: Array as PropType<ISelectOption[]>,
      default: () => [],
    },

    isEnglishModelValid: {
      type: Boolean,
      default: true,
    },

    editedValidatorObject: {
      type: Object,
      default: () => ({}),
    },

    compareToValidatorObject: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      input: '',
      toggleKey: 0,
      translationKey: 0,
    };
  },

  computed: {
    isTranslationModelDifferent(): boolean {
      return this.$utils.isObjectDifferent(this.editedValidatorObject, this.compareToValidatorObject, true);
    },
  },

  watch: {
    '$rsGlobals.$language': {
      immediate: true,
      handler() {
        this.input = this.$rsGlobals.$language;
      },
    },
  },

  mounted() {
    if (this.resetOnMountAndDestroy && this.$rsGlobals.$isTranslateMode) {
      this.$eventBus.$emit('set-language', 'en');
    }
  },

  beforeDestroy() {
    if (this.resetOnMountAndDestroy && this.$rsGlobals.$isTranslateMode) {
      this.$eventBus.$emit('set-language', 'en');
    }
  },

  methods: {
    async handleLanguageChange(language?: string) {
      if (this.isTranslationModelDifferent && this.$rsGlobals.$language !== language) {
        this.$rsGlobals.$rsSwal.warning({
          title: this.$rsGlobals.$isTranslateMode ? `You have unsaved translations!` : 'You have unsaved changes!',
          confirmHandler: async () => {
            if (this.isEnglishModelValid || this.$rsGlobals.$isTranslateMode) {
              this.$emit('submit');
              await this.showSuccessMsg();
              this.$eventBus.$emit('set-language', language);
            } else {
              await this.showErrorMsg();
              this.translationKey += 1;
            }
          },
          rejectHandler: () => {
            this.$eventBus.$emit('set-language', language);
          },
          confirmWithoutSaveHandler: () => {
            this.input = this.$rsGlobals.$language;
            this.toggleKey += 1;
          },
        });
      } else {
        this.$eventBus.$emit('set-language', language);
      }
    },

    showErrorMsg() {
      return this.$swal.fire({
        icon: 'error',
        title: 'Form is invalid.',
        confirmButtonColor: '#dd6b55',
        confirmButtonText: `OK`,
      }).then((result: any) => result);
    },

    showSuccessMsg() {
      return this.$swal.fire({
        icon: 'success',
        title: this.$rsGlobals.$isTranslateMode ? `Translations Save Successful!` : 'Save Successful!',
        confirmButtonColor: '#00a889',
        confirmButtonText: `OK`,
      }).then((result: any) => result);
    },
  },
});
</script>

<style lang="scss" scoped>
</style>
